<template>
  <div class="teacher-wrapper">
    <div class="main-title">{{ menu.module_name }}</div>
    <div class="teacher-list" v-if="teacherList && teacherList.length">
      <TeacherCard
        v-for="(teacherData, index) in teacherList"
        :teacherData="teacherData"
        :key="teacherData.teacher_id"
        :menu="menu"
        :style="{ '--delay': `${index * 0.3}s` }"
        class="animated-card"
        @mouseenter="currentIndex = -1"
        :class="{ 'animated-card-first': index === 0, active: currentIndex === index }"
      />
    </div>
    <div v-else class="no-data">
      <Empty type="people" text="暂无教学名师" />
    </div>
    <div class="more-btn" @click="handleMore" v-if="teacherList && teacherList.length > 0">
      <span class="text">查看更多</span>
      <div class="icon-container">
        <div class="icon"></div>
      </div>
    </div>
  </div>
</template>
<script>
import TeacherCard from 'components/TeacherCard'
import { Empty } from 'zhs-components'
export default {
  components: {
    TeacherCard,
    Empty
  },
  props: {
    menu: Object
  },
  created() {
    this.getTeacherList()
  },
  data() {
    return {
      teacherList: [],
      dialogTeacherVisible: false,
      currentTeacher: {},
      currentIndex: 0
    }
  },
  methods: {
    handleMore() {
      window.open(
        `/teacherList.html?type=1&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`
      )
    },
    async getTeacherList() {
      const list = await this.$http.getHomeTeachers({
        num: this.menu.num,
        menu_id: this.menu.menu_id
      })
      console.log('名师', list)
      this.teacherList = list
    }
  }
}
</script>
<style lang="scss" scoped>
.animate-wrap {
  &.visible {
    .animated-card {
      opacity: 0;
      animation: slideIn 1s linear forwards;
      animation-delay: var(--delay, 0.7s);
      &.animated-card-first {
        opacity: 1;
        animation-delay: 0;
        animation: sildeInFirst 0.3s linear;
      }
    }
  }
  @keyframes sildeInFirst {
    from {
      opacity: 0;
      transform: translate(-100px, -24px);
    }
    to {
      opacity: 1;
      transform: translate(0px, -24px);
    }
  }
  @keyframes slideIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}
.teacher-wrapper {
  height: 713px;
  padding: 60px 60px;
  box-sizing: border-box;
  position: relative;
  width: 1440px;
  .main-title {
    color: #1c212a;
    font-family: 'Alibaba PuHuiTi';
    font-size: 32px;
    font-weight: 700;
    &::before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 24px;
      background-color: #194189;
      margin-right: 8px;
    }
  }
  .teacher-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px;
    margin-top: 86px;
  }
  .more-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 140px;
    height: 48px;
    border: 1px solid #1d2129;
    border-radius: 6px;
    margin-top: 28px;
    cursor: pointer;
    &:hover {
      border-color: #194189;
      span {
        color: #194189;
      }
      .icon-container {
        .icon {
          animation: btnFadeIn 0.2s ease-in-out;
          background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/fe207a0f99cb41778f240046e6e39454.png');
        }
      }
    }
    span {
      color: #1d2129;
      font-size: 16px;
      font-weight: 500;
    }
    .icon-container {
      width: 32px;
      height: 32px;
      .icon {
        width: 100%;
        height: 100%;
        background-image: url('https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/7d4b70c240b44e8d9844754f33039606.png');
        background-size: 100% 100%;
      }
    }
  }
  @keyframes btnFadeIn {
    0% {
      opacity: 0;
      width: 0;
      height: 100%;
    }
    100% {
      opacity: 1;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
